const routes = [
  //  临时通知
  {
    path: "/home/tempNotice",
    name: "tempNotice",
    meta: {
      title: "",
    },
    component: (resolve) => require(["@/views/other/tempNotice"], resolve),
  },
  //  联系雅曼
  {
    path: "/home/notice",
    name: "notice",
    meta: {
      title: "",
    },
    component: (resolve) => require(["@/views/other/notice"], resolve),
  },
  //  雅曼广播站
  {
    path: "/home/introduce",
    name: "introduce",
    meta: {
      title: "",
    },
    component: (resolve) => require(["@/views/other/introduce"], resolve),
  },
  {
    path: "/home/manual",
    name: "manual",
    meta: {
      title: "",
    },
    component: (resolve) => require(["@/views/other/manual"], resolve),
  },
  {
    path: "/home/treaty",
    name: "treaty",
    meta: {
      title: "",
    },
    component: (resolve) => require(["@/views/other/treaty"], resolve),
  },
  {
    path: "/home/thirdTest",
    name: "thirdTest",
    meta: {
      title: "",
    },
    component: (resolve) => require(["@/views/other/thirdTest"], resolve),
  },
  {
    path: "/home/login",
    name: "login",
    meta: {
      title: "",
    },
    component: (resolve) => require(["@/views/other/login"], resolve),
  },
];

export default routes;
